<template>
  <v-container class="black-cont" fluid fill-height >
    <v-layout justify-center ma-1>
      <v-flex xs9 align-self-center>
        <v-card href="https://github.com/erik-feller" class="text-xs-center" dark>
          <v-card-title class="justify-center" >GitHub</v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center ma-1>
      <v-flex xs9 align-self-center class="text-xs-center">
        <v-card href="https://www.linkedin.com/in/erik-feller-519655179/" dark>
          <v-card-title class="justify-center" >LinkedIn</v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "contact"
};
</script>
